import { Button, Container, Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import BaseModal from './BaseModal'

export default function ServiceUserModal({
	show,
	onHide,
	otherProps,
	isLoading = false,
	onClick,
}) {
	const { t } = useTranslation()

	return (
		<BaseModal show={show} onHide={onHide} {...otherProps}>
			<Container className="baseinput-container modal-createroom" fluid>
				<Modal.Body>
					<div
						className='service-user-modal'>
						<h4
							className="text-center"
							style={{
								fontWeight: 700,
								fontSize: '20px',
								lineHeight: '29px',
								background:
									'linear-gradient(180deg, #F39500 18.23%, #FCF35894 65%)',
								WebkitBackgroundClip: 'text',
								WebkitTextFillColor: 'transparent',
								paddingBottom: '40px',
							}}
						>
							{t('modal.modal.service_user')}
						</h4>
						<p
							className="text-center"
							style={{
								fontWeight: 500,
								fontSize: '13px',
								lineHeight: '18px',
								color: '#B1B5C3',
							}}
						>
							{t('event.go_to_store')}
						</p>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button disabled={isLoading} variant="secondary" onClick={onClick}>
						{t('event.register')}
					</Button>
				</Modal.Footer>
			</Container>
		</BaseModal>
	)
}
